import styles from '../../styles/plan/review.scss';

const Review = (props: any) => (
  <div className={styles.review}>
    <p className={styles.quote}>" {props.data.review} "</p>
    <div className={styles.author}>
      <label className={styles.name}>{props.data.author.name}</label>
      <span className={styles.designation}>{props.data.author.identity}</span>
    </div>
  </div>
);

export default Review;



// WEBPACK FOOTER //
// ./components/plan/review.tsx